var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSadFaceBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.5,
    height: 15.5,
    viewBox: "0 0 15.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icono_malo",
    transform: "translate(-8782.751 -2092.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_121",
    "data-name": "Uni\\xF3n 121",
    d: "M-359.832,345.5l-.178-.023c-.13-.016-.266-.033-.4-.054a7.848,7.848,0,0,1-4.006-1.885,7.767,7.767,0,0,1-2.325-3.749,9.637,9.637,0,0,1-.258-1.459l0-.028,0-1.13c.008-.061.015-.122.023-.182.017-.134.034-.273.055-.409a7.693,7.693,0,0,1,1.874-3.981,7.7,7.7,0,0,1,3.73-2.328,9.976,9.976,0,0,1,1.488-.267h.029l1.13,0,.186.024c.132.017.269.034.4.054a7.694,7.694,0,0,1,3.97,1.864,7.767,7.767,0,0,1,2.335,3.725,9.99,9.99,0,0,1,.271,1.5v.029l0,1.132c-.012.08-.022.161-.032.241-.023.175-.047.355-.077.534a7.676,7.676,0,0,1-1.949,3.91,7.7,7.7,0,0,1-3.747,2.246,10.877,10.877,0,0,1-1.363.234l-.015,0Zm-3.87-12.193a6.232,6.232,0,0,0-1.834,4.449,6.248,6.248,0,0,0,1.834,4.45,6.253,6.253,0,0,0,4.452,1.832,6.253,6.253,0,0,0,4.46-1.84,6.258,6.258,0,0,0,1.826-4.45A6.235,6.235,0,0,0-354.8,333.3a6.333,6.333,0,0,0-4.452-1.844A6.337,6.337,0,0,0-363.7,333.305Z",
    transform: "translate(9149.751 1762.749)",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_122",
    "data-name": "Uni\\xF3n 122",
    d: "M-360.325,333.011l-.065-.1a3.1,3.1,0,0,0-.255-.362,2.93,2.93,0,0,0-2.485-1.064,2.9,2.9,0,0,0-2.493,1.48.766.766,0,0,1-.646.382.734.734,0,0,1-.359-.1.729.729,0,0,1-.349-.447.758.758,0,0,1,.091-.586,4.374,4.374,0,0,1,2.929-2.117,4.667,4.667,0,0,1,.977-.1h.005a4.437,4.437,0,0,1,3.758,2.01,1.988,1.988,0,0,1,.166.284.732.732,0,0,1-.3.958.744.744,0,0,1-.363.1A.729.729,0,0,1-360.325,333.011Z",
    transform: "translate(9153.49 1770.695)",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_123",
    "data-name": "Uni\\xF3n 123",
    d: "M-365.808,332.4A1.226,1.226,0,0,1-367,331.189,1.206,1.206,0,0,1-365.793,330a1.187,1.187,0,0,1,1.2,1.2,1.2,1.2,0,0,1-.355.856,1.18,1.18,0,0,1-.841.352Z",
    transform: "translate(9153.953 1767.428)",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_124",
    "data-name": "Uni\\xF3n 124",
    d: "M-365.805,332.4A1.209,1.209,0,0,1-367,331.2a1.186,1.186,0,0,1,1.194-1.2,1.211,1.211,0,0,1,.868.359,1.182,1.182,0,0,1,.344.848,1.226,1.226,0,0,1-1.2,1.2Z",
    transform: "translate(9158.643 1767.428)",
    fill: "#2c2c2c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSadFaceBlack);
export default __webpack_public_path__ + "static/media/icon_sad_face_black.4502c0446431cbf28cb760f0b122f18e.svg";
export { ForwardRef as ReactComponent };